// src/theme/theme.ts
export type ThemeMode = "light" | "dark" | "midnight";
export type ThemePreset = "romantic" | "mature";

export type Theme = {
  mode: ThemeMode;
  bg: string;
  surface: string;
  surface2: string;
  text: string;
  muted: string;
  border: string;
  primary: string;
  primary2: string;
  danger: string;
  chip: string;
  chipText: string;
  shadow: string;
  romanticGlow: string;
};

// Copied from the app palette so web matches 1:1.:contentReference[oaicite:4]{index=4}
export const THEMES: Record<ThemeMode, Theme> = {
  light: {
    mode: "light",
    bg: "#FFF7FB",
    surface: "#FFFFFF",
    surface2: "#FFF0F7",
    text: "#1A1320",
    muted: "#6B5C6A",
    border: "#E9D7E6",
    primary: "#D946EF",
    primary2: "#FB7185",
    danger: "#EF4444",
    chip: "#FCE7F3",
    chipText: "#9D174D",
    shadow: "rgba(26,19,32,0.12)",
    romanticGlow: "rgba(217,70,239,0.20)",
  },
  dark: {
    mode: "dark",
    bg: "#0B0A10",
    surface: "#141223",
    surface2: "#1B1730",
    text: "#F7F0FF",
    muted: "#B8AFC7",
    border: "#2A2543",
    primary: "#D946EF",
    primary2: "#FB7185",
    danger: "#F87171",
    chip: "#2A1530",
    chipText: "#FBCFE8",
    shadow: "rgba(0,0,0,0.35)",
    romanticGlow: "rgba(251,113,133,0.18)",
  },
  midnight: {
    mode: "midnight",
    bg: "#05040A",
    surface: "#0E0C18",
    surface2: "#151128",
    text: "#F6F2FF",
    muted: "#AFA7C6",
    border: "#241F3D",
    primary: "#A855F7",
    primary2: "#F472B6",
    danger: "#FB7185",
    chip: "#1B1430",
    chipText: "#F5D0FE",
    shadow: "rgba(0,0,0,0.45)",
    romanticGlow: "rgba(168,85,247,0.18)",
  },
};

export function applyPreset(base: Theme, preset: ThemePreset): Theme {
  if (preset === "romantic") return base;

  // Matches your app’s “mature accent” preset logic.:contentReference[oaicite:5]{index=5}
  return {
    ...base,
    primary: base.mode === "light" ? "#6D28D9" : "#8B5CF6",
    primary2: base.mode === "light" ? "#A78BFA" : "#C4B5FD",
    romanticGlow: base.mode === "light" ? "rgba(109,40,217,0.20)" : "rgba(139,92,246,0.25)",
    chip: base.mode === "light" ? "#EEF2FF" : "#1A1433",
    chipText: base.mode === "light" ? "#3730A3" : "#C7D2FE",
  };
}
